import { Text } from "@/components/ui"
import { CouponCodeChip } from "./CouponCodeChip"

/** The first line of a coupon ticket: the benefit ("10% OFF") beside its code, on one line; the code truncates when space runs out. */
export function CouponTicketTitle({ headline, code }: { headline: string; code: string }) {
  return (
    <div className="flex min-w-0 items-center gap-2">
      <Text as="span" size="base" weight="semibold" leading="none" family="game-display" tone="default" className="shrink-0 whitespace-nowrap">
        {headline}
      </Text>
      <CouponCodeChip code={code} />
    </div>
  )
}
